import React from "react";
import IconText from "./IconText.jsx";

export default function IconTextCard({ item, ...restProps }) {
  if (!item) return null;
  return <IconText {...item} {...restProps} />;
}